import React from "react";
import { Segment, Message, Icon, Header, Form } from "semantic-ui-react";
import { Field } from "redux-form";

function renderTextField({
  input,
  meta: { touched, error, warning },
  ...others
}) {
  let color = touched && ((error && "red") || (warning && "yellow"));
  let mensaje =
    touched &&
    ((error && <span>{error}</span>) || (warning && <span>{warning}</span>));

  return (
    <React.Fragment>
      <Form.Input {...input} {...others} />
      {touched &&
        ((error || warning) && (
          <Message negative>
            <Message.Header>
              <Icon
                name="warning circle"
                style={{
                  color
                }}
              />
              {mensaje}
            </Message.Header>
          </Message>
        ))}
    </React.Fragment>
  );
}

const required = value => (value ? undefined : "Requerido");

function DatosContacto(props) {
  return (
    <Segment>
      <Header as="h3">Datos de Contacto</Header>
      <label>
        <strong>Teléfonos de Contacto</strong>
        {"   "}
      </label>
      <label>(Deben estar operativos durante el horario de la escuela)</label>
      <Field
        id="telefonos"
        name="telefonos"
        type="text"
        component={renderTextField}
        validate={[required]}
      />

      <label>
        <strong>Email</strong>
      </label>
      {"   "}
      <label>
        (La dirección de email será necesaria para la comunicación de noticias
        importantes y confirmación de la inscripción)
      </label>
      <Field
        id="email"
        name="email"
        type="text"
        component={renderTextField}
        validate={[required]}
      />
    </Segment>
  );
}

export default DatosContacto;



// WEBPACK FOOTER //
// ./src/pages/inscripciones/hojaInscripcion/formularioInscripcion/DatosContacto.jsx